import { toast } from "@/components/common/Toast";
import { isInApp } from "./bridge";
import { nativeMethod } from "./bridge/methods";
import { callAppBridge } from "./callApp/index";
import { launchApp, launchAppWithCallback } from "@/utils/callApp/index";
import { formatFileSize } from "./format";

export function syncUrlSearchParams(
  params: Record<string, string | number | null | undefined>
) {
  if (typeof window === "undefined") return "";

  const currentUrl = new URL(window.location.href);

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") {
      currentUrl.searchParams.delete(key);
      return;
    }

    currentUrl.searchParams.set(key, String(value));
  });

  window.history.replaceState({}, "", currentUrl.toString());
  return currentUrl.toString();
}

export const getDriveUrl = () => {
  const current = new URL(window.location.href);
  const origin = current.origin;
  const pathname = current.pathname;

  // 规范化路径：无论前面是否带语言等前缀，统一裁剪为 /drive/s/{code}
  const marker = "/drive/s/";
  const pos = pathname.indexOf(marker);
  let codeSeg = "";
  if (pos >= 0) {
    codeSeg = pathname.slice(pos + marker.length).split("/")[0] || "";
  }

  // 拼接当前 URL 的所有 query 参数到新的链接上
  const searchParams = new URLSearchParams(current.search);
  // 路径中已包含 code，移除 query 中的重复项
  searchParams.delete("code");
  const queryString = searchParams.toString();

  const cleaned = `${origin}${marker}${codeSeg}${queryString ? `?${queryString}` : ""}`;
  return cleaned;
};
export const initSafeArea = async () => {
  if (!isInApp()) return;
  const safeArea = await nativeMethod.getAppbar();
  console.log("safeArea", safeArea);
  // document.documentElement.style.setProperty('--safe-area-bottom', safeArea?.safeAreaBottom + 'px')
  window.safeArea = safeArea;
  return safeArea;
};
export const getStreamBaseUrl = () => {
  const streamUrl = process.env.NEXT_PUBLIC_BASE_URL_STREAM;

  if (!streamUrl) {
    if (process.env.NEXT_PUBLIC_ENV === "production") {
      console.error("NEXT_PUBLIC_BASE_URL_STREAM is not configured");
    }
    // 返回默认的流式请求地址
    return process.env.NEXT_PUBLIC_BASE_URL || "https://h5-api.buscari.com";
  }

  return streamUrl;
};

export function genKey(length = 16) {
  const random =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let str = "";
  for (let i = 0; i < length; i++) {
    str = str + random.charAt(Math.random() * random.length);
  }
  return str;
}
function isRef(r: any): boolean {
  /*判断该值的__v_isRef属性是否为true,因为前面r=0,并没有所谓__v_isRef属性，所以这里r.__v_isRef是为undefined。这里的返回值是为false
   */
  return !!(r && r.__v_isRef === true);
}
export function convertObj(data = {}, isSort = false) {
  if (!data || typeof data !== "object") return "";
  const _result = [];
  // 1. 获取所有 key，倒序排序
  let keys = Object.keys(data);
  if (isSort) {
    keys = keys.sort((a, b) => (a < b ? 1 : -1));
  }
  for (const key of keys) {
    const value = data[key];
    if (value === null || typeof value === "undefined") continue;

    if (Array.isArray(value)) {
      // 判断数组元素类型
      if (
        value.length > 0 &&
        typeof value[0] === "object" &&
        value[0] !== null
      ) {
        // 数组元素为对象，递归排序并倒序
        const arr = isSort
          ? [...value].sort((a, b) =>
              JSON.stringify(a) < JSON.stringify(b) ? 1 : -1
            )
          : value;
        arr.forEach(function (_value, index) {
          _result.push(key + "=" + convertObj(_value, true));
        });
      } else {
        // 数组元素为字符串，保持原顺序
        value.forEach(function (_value, index) {
          _result.push(key + "[" + index + "]" + "=" + _value);
        });
      }
    } else if (Object.prototype.toString.call(value) == "[object Object]") {
      _result.push(key + "=" + convertObj(value, true));
    } else {
      _result.push(key + "=" + value);
    }
  }

  return _result
    .map((item) => {
      return item.substring(item.indexOf("=") + 1);
    })
    .join("");
}
// export function convertObj(data = {} as any, isSort = false): string {
//   var _result = [];
//   for (var key in data) {
//     var value = isRef(data[key]) ? data[key].value : data[key];
//     if (value === null || typeof value === 'undefined') continue;
//     if (Array.isArray(value)) {
//       // console.log('数组的参数', { value });
//       value.forEach(function (_value, index) {
//         //_result.push(_value)
//         if (Object.prototype.toString.call(_value) == '[object Object]') {
//           _result.push(key + '=' + convertObj(_value, true));
//         } else if (Array.isArray(_value)) {
//           _result.push(key + '=' + convertObj({ key: _value }, false));
//         } else {
//           _result.push(key + '[' + index + ']' + '=' + _value);
//         }
//       });
//     } else if (Object.prototype.toString.call(value) == '[object Object]') {
//       _result.push(key + '=' + convertObj(value, true));
//     } else {
//       //_result.push(value)
//       _result.push(key + '=' + value);
//     }
//   }
//   // console.log('_result', _result);
//   // if (isSort) _result.sort();
//   if (isSort) {
//     let maps = {};
//     _result.forEach((item) => {
//       let [key, val] = item.split('=');
//       if (maps[key]) {
//         maps[key].push(val);
//       } else {
//         maps[key] = [val];
//       }
//     });
//     let mapKeySort = Object.keys(maps).sort();
//     return mapKeySort.map((key) => maps[key].join('')).join('');
//   }
//   return _result
//     .map((item) => {
//       return item.substring(item.indexOf('=') + 1);
//     })
//     .join('');
//   // return Crypto.base64Encode(
//   //   _result
//   //     .map((item) => {
//   //       return item.substring(item.indexOf('=') + 1);
//   //     })
//   //     .join('')
//   // );
// }

// export function convertObj(data = {}, isSort = false) {
//   var _result = [];

//   for (var key in data) {
//     var value = data[key];
//     if (value === null || typeof value === 'undefined') continue;
//     console.log('key',key,'value',value)
//     if (Array.isArray(value)) {
//       // 新增：数组排序
//       // const arr = value.sort()
//       // console.log('arr=====',arr)
//       // const arr = isSort ? [...value].sort().reverse()
//       // : value;
//       value.forEach(function (_value, index) {
//         //_result.push(_value)
//         if (Object.prototype.toString.call(_value) == '[object Object]') {
//           console.log('值为对象')
//           _result.push(key + '=' + convertObj(_value, true));
//         } else if (Array.isArray(_value)) {
//           console.log('值为数组')
//           _result.push(key + '=' + convertObj({ key: _value }, false));
//         } else {
//           console.log('值为字符串')
//           _result.push(key + '[' + index + ']' + '=' + _value);
//         }
//       });
//     } else if (Object.prototype.toString.call(value) == '[object Object]') {
//       _result.push(key + '=' + convertObj(value, true));
//     } else {
//       //_result.push(value)
//       _result.push(key + '=' + value);
//     }
//   }
//   if (isSort)
//     _result.sort(function compareFn(a, b) {
//       if (a < b) {
//         return 1;
//       }
//       if (a > b) {
//         return -1;
//       }
//       // a 一定等于 b
//       return 0;
//     });
//   console.log('_result', _result);
//   console.log('_result处理后', _result
//     .map((item) => {
//       return item.substring(item.indexOf('=') + 1);
//     })
//     .join(''));
//   console.log(
//     'go',
//     _result
//       .map((item) => {
//         return item.substring(item.indexOf('=') + 1);
//       })
//       .join('')
//   );
//   //console.log(_result);
//   return _result
//       .map((item) => {
//         return item.substring(item.indexOf('=') + 1);
//       })
//       .join('')

// }
// 跳转app分享
// export function jumpAppShare() {
//   // 使用的时候记得去处url中的语言
//   const url = `seekee://jump/netdiskShare?url=${window.location.href}`;
//   // window.open(url);
//   window.location.href = url;
// }
// 跳转app网盘首页
export function jumpAppNetdiskHome() {
  const url = "seekee://jump/netdiskHome";
  window.location.href = url;
}

export const formatDateTime = (dateStr: string | number | Date) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${year}.${month}.${day} ${hours}:${minutes}:${seconds}`;
};

export const formatShareUserName = (userName: string): string => {
  if (!userName) return "";
  const len = userName.length;
  if (len === 1) {
    return userName + "**";
  }
  if (len === 2) {
    return userName[0] + "**" + userName[1];
  }
  if (len === 3 || len === 4) {
    return userName[0] + "**" + userName[len - 1];
  }
  if (len >= 5) {
    if (len % 2 === 0) {
      // 偶数，取中间两个字符变**
      const n1 = (len - 2) / 2;
      return userName.slice(0, n1) + "**" + userName.slice(n1 + 2);
    } else {
      // 奇数，最中间的一个字符变**
      const mid = Math.floor(len / 2);
      return userName.slice(0, mid) + "**" + userName.slice(mid + 1);
    }
  }
  return userName;
};
// export const formatShareUserName = (
//   userName: string,
// ): string => {
//   if (!userName) return '';
//   const len = userName.length;
//   if (len === 1) {
//     return userName + '**';
//   }
//   if (len === 2) {
//     return userName[0] + '**' + userName[1];
//   }
//   if (len === 3 || len === 4) {
//     return userName[0] + '**' + userName[len - 1];
//   }
//   if (len >= 5) {
//     // 动态计算中间**的位置
//     const n1 = Math.floor((len - 2) / 2);
//     // const n2 = len - n1 - 2;
//     return userName.slice(0, n1) + '**' + userName.slice(n1 + 2);
//   }
//   return userName;
// };
